module.exports = __webpack_public_path__ + "img/logo9.11f0c960.png";